import React, { useState, createContext } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';

import { ExternalSignIn, SellerSignIn } from 'containers';
import { useAppContext } from 'utils/hooks';

/**
 * @type {React.Context<{
 *   authCache: Object|null,
 *   onAuthenticated: (authCache: Object, redirectPath?: string) => void
 * }>}
 */
export const AuthGuardContext = createContext({
  authCache: null,
  onAuthenticated: () => {}
});

export function AuthGuardProvider({ children = null }) {
  const { replace } = useHistory();

  const [authCache, setAuthCache] = useState(null);

  const { isSSRMode } = useAppContext();

  const onAuthenticated = (data, redirectPath = '/') => {
    setAuthCache(data);
    replace(redirectPath);
  };

  return (
    <AuthGuardContext.Provider value={{ authCache, onAuthenticated }}>
      <Switch>
        {/* SSR */}
        {isSSRMode && (
          <Route key="ssr-login" path="/seller-signin">
            <SellerSignIn />
          </Route>
        )}

        {/* Warren */}
        {!isSSRMode && (
          <Route key="warren-login" path="/signin">
            <ExternalSignIn />
          </Route>
        )}

        <Route key="app-routes" path="/">
          {children}
        </Route>
      </Switch>
    </AuthGuardContext.Provider>
  );
}
